import React, { useEffect, useState } from 'react';
import { Button, Form, Badge, Table, Modal } from 'react-bootstrap';
import ModalListPicker from '../../../components/Modals/ModalListPicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



export default function DGLTH_order_list({ item, entity = null, data, setData }) {

    //const [qta, setQta] = useState(parseFloat(parseFloat(item.requested_quantity) + parseFloat(item.minStockQuantity) - parseFloat(item.futureAvailability)).toFixed(2))
    const [qta, setQta] = useState(parseFloat(parseFloat(item.requested_quantity) - (parseFloat(item.stockQuantityInternal) + parseFloat(item.stockQuantitySuppliers)) + parseFloat(item.minStockQuantity) - parseFloat(item.orderedQuantity)).toFixed(2))
    const [supplier, setSupplier] = useState(item.id_supplier)
    const [defaultSupplier, setDefaultSupplier] = useState(null)
    const [modalOpen, setModalOpen] = useState(false)
    const [showFmModal, setShowFmModal] = useState(false)

    const defaultSearchObj = {
        'query': '',
        'fields': [],
        'constraints': [{ fieldName: "idItemModel", type: "value", value: parseInt(item.idItemModel) }, { fieldName: "active", type: "value", value: 1 }]
    }



    useEffect(() => {
        setQta(parseFloat(parseFloat(item.requested_quantity) - (parseFloat(item.stockQuantityInternal) + parseFloat(item.stockQuantitySuppliers)) + parseFloat(item.minStockQuantity) - parseFloat(item.orderedQuantity)).toFixed(2))
        if(item.supplier_price) {
            setDefaultSupplier(item.supplier_name)
        }
        else {
            setDefaultSupplier(null)
        }
    }, [item]);


    useEffect(() => {
        const nextData = [...data]
        nextData.map((obj) => {
            if (obj.id === item.id) {
                obj.input_supplier = supplier;
            }
        });
        setData(nextData);
    }, [supplier]);


    useEffect(() => {
        if (qta) {
            updateQta()
        }
    }, [qta]);


    function updateQta() {
        const nextData = [...data]
        nextData.map((obj) => {
            if (obj.id === item.id) {
                obj.input_qta = qta;
            }
        });
        setData(nextData);
    }

    function openModal() {
        setModalOpen(true)
    }

    function closeModal() {
        setModalOpen(false)
    }

    function selectRow(el) {
        console.log(el)
        setSupplier(el.idSupplier.id)
        setDefaultSupplier(el.idSupplier.name)
        closeModal()
    }

    // Parse sourceRows JSON
    function getSourceRows() {
        if (!item.sourceRows) return [];
        try {
            if (typeof item.sourceRows === 'string') {
                return JSON.parse(item.sourceRows);
            }
            if (Array.isArray(item.sourceRows)) {
                return item.sourceRows;
            }
            return [];
        } catch (e) {
            return [];
        }
    }

    function getOutOfSizeRows() {
        return getSourceRows().filter(r => r.outOfSize === 1);
    }


    return (
        <>
            <Table className='text-start border'>
                <tbody>
                    <tr>
                        <td>
                            <Form.Control style={{ minWidth: 80, maxWidth: 120 }} value={qta} onChange={(event) => setQta(event.target.value)} size="sm" type="number" step="0.01" placeholder="Qta da ordinare" />
                        </td>
                        <td>
                            <Badge>{defaultSupplier}</Badge>
                            <FontAwesomeIcon className='ms-2' role='button' onClick={() => openModal()} icon={'edit'} color='#999999' />
                        </td>
                        {parseInt(item.hasOutOfSize) === 1 ? (
                            <td>
                                <Badge bg='warning' text='dark' role='button' onClick={() => setShowFmModal(true)} title='Contiene righe fuori misura'>
                                    FM {item.outOfSizeQuantity ? `(${item.outOfSizeQuantity})` : ''}
                                </Badge>
                            </td>
                        ) : null}
                    </tr>
                </tbody>
            </Table>

            {modalOpen ? (
                <ModalListPicker entity={'item_model_suppliers'} closeModal={closeModal} modalStatus={modalOpen} selectRow={selectRow} defaultSearchObj={defaultSearchObj} />
            ) : (
                <></>
            )}

            <Modal show={showFmModal} onHide={() => setShowFmModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Dettagli fuori misura - {item.item_model_code}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {getOutOfSizeRows().length > 0 ? (
                        <Table bordered striped hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Ordine cliente</th>
                                    <th>Cliente</th>
                                    <th>Descrizione</th>
                                    <th>Quantità</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getOutOfSizeRows().map((row, i) => (
                                    <tr key={i}>
                                        <td>{row.customerOrderCode || '-'}</td>
                                        <td>{row.customerName || '-'}</td>
                                        <td>{row.description || '-'}</td>
                                        <td>{row.quantity || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    ) : (
                        <p>Nessun dettaglio disponibile.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowFmModal(false)}>Chiudi</Button>
                </Modal.Footer>
            </Modal>

        </>
    )
};
